import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentPlanRequestPage } from './payment-plan-request.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentPlanRequestPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentPlanRequestPageRoutingModule {}
